import { getMRT_RowSelectionHandler as getMRTRowSelectionHandler } from 'material-react-table';

export function tryParse(jsonish) {
  if (jsonish === null) return [];
  try {
    return JSON.parse(jsonish);
  } catch {
    return [];
  }
}

function idfn(x) {
  return x.id;
}

export function defaultTableOptions(selection) {
  return {
    getRowId: idfn,
    enableExpandAll: false,
    enableFacetedValues: true,
    // Not using align: center because it makes the table render too wide for the page
    muiTableHeadCellProps: {
      sx: {
        textAlign: 'center',
        verticalAlign: 'middle',
        '& .Mui-TableHeadCell-Content': {
          justifyContent: 'center',
        },
      },
    },
    muiTableBodyCellProps: { sx: { textAlign: 'center', verticalAlign: 'middle' } },
    muiTableBodyRowProps: ({ row, staticRowIndex, table }) => ({
      onClick: (event) => getMRTRowSelectionHandler({ row, staticRowIndex, table })(event), // import this helper function from material-react-table
      sx: { cursor: 'pointer' },
    }),
    // selection
    enableBatchRowSelection: selection,
    enableMultiRowSelection: selection,
    enableRowSelection: selection,
    enableSelectAll: selection,
  };
}

export function defaultTableInitialState(columnFilters, sorting) {
  return {
    columnFilters,
    showColumnFilters: columnFilters.length !== 0,
    sorting,
  };
}

export function extractSortingParams(searchParams) {
  return Object.entries(tryParse(searchParams.get('sortBy'))).map(([id, desc]) => ({ id, desc }));
}

export function extractFilterParams(searchParams) {
  return Object.entries(tryParse(searchParams.get('filterBy'))).map(([id, value]) => ({
    id,
    value,
  }));
}

export function setSorting(updater, sorting, setSearchParams) {
  let newSorting = typeof updater === 'function' ? updater(sorting) : updater;
  if (newSorting !== sorting) {
    if (newSorting.length === 0)
      setSearchParams((params) => {
        params.delete('sortBy');
        return params;
      });
    else {
      newSorting = Object.fromEntries(newSorting.map(({ id, desc }) => [id, desc]));
      setSearchParams((params) => {
        params.set('sortBy', JSON.stringify(newSorting));
        return params;
      });
    }
  }
}

export function setFilters(updater, columnFilters, setSearchParams) {
  let newColumnFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
  if (newColumnFilters !== columnFilters) {
    if (newColumnFilters.length === 0)
      setSearchParams((params) => {
        params.delete('filterBy');
        return params;
      });
    else {
      newColumnFilters = Object.fromEntries(
        newColumnFilters.map(({ id, value }) => [
          id,
          Array.isArray(value) ? value.map((v) => v || '') : value,
        ])
      );
      setSearchParams((params) => {
        params.set('filterBy', JSON.stringify(newColumnFilters));
        return params;
      });
    }
  }
}
